/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://static.nrk.no/dh/dh-plast-quiz/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/**
 * JSX/hyperscript reviver.
 * @see http://jasonformat.com/wtf-is-jsx
 * Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *
 * Note: this is exported as both `h()` and `createElement()` for compatibility reasons.
 *
 * Creates a VNode (virtual DOM element). A tree of VNodes can be used as a lightweight representation
 * of the structure of a DOM tree. This structure can be realized by recursively comparing it against
 * the current _actual_ DOM structure, and applying only the differences.
 *
 * `h()`/`createElement()` accepts an element name, a list of attributes/props,
 * and optionally children to append to the element.
 *
 * @example The following DOM tree
 *
 * `<div id="foo" name="bar">Hello!</div>`
 *
 * can be constructed using this function as:
 *
 * `h('div', { id: 'foo', name : 'bar' }, 'Hello!');`
 *
 * @param {string} nodeName	An element name. Ex: `div`, `a`, `span`, etc.
 * @param {Object} attributes	Any attributes/props to set on the created element.
 * @param rest			Additional arguments are taken to be children to append. Can be infinitely nested Arrays.
 *
 * @public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

/**
 *  Copy all properties from `props` onto `obj`.
 *  @param {Object} obj		Object onto which properties should be copied.
 *  @param {Object} props	Object from which to copy properties.
 *  @returns obj
 *  @private
 */
function extend(obj, props) {
	for (var i in props) {
		obj[i] = props[i];
	}return obj;
}

/**
 * Call a function asynchronously, as soon as possible. Makes
 * use of HTML Promise to schedule the callback if available,
 * otherwise falling back to `setTimeout` (mainly for IE<11).
 *
 * @param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

/**
 * Clones the given VNode, optionally adding attributes/props and replacing its children.
 * @param {VNode} vnode		The virutal DOM element to clone
 * @param {Object} props	Attributes/props to add when cloning
 * @param {VNode} rest		Any additional arguments will be used as replacement children.
 */
function cloneElement(vnode, props) {
	return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/**
 * Check if two nodes are equivalent.
 *
 * @param {Node} node			DOM Node to compare
 * @param {VNode} vnode			Virtual DOM node to compare
 * @param {boolean} [hyrdating=false]	If true, ignores component constructors when comparing.
 * @private
 */
function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

/**
 * Check if an Element has a given nodeName, case-insensitively.
 *
 * @param {Element} node	A DOM Element to inspect the name of.
 * @param {String} nodeName	Unnormalized name to compare against.
 */
function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 *
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},

	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},

	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
	return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

exports.h = h;
exports.createElement = h;
exports.cloneElement = cloneElement;
exports.Component = Component;
exports.render = render;
exports.rerender = rerender;
exports.options = options;
exports.default = preact;
//# sourceMappingURL=preact.esm.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = exports.getScrollTop = exports.getScrollLeft = exports.createUniqueId = exports.bem = undefined;

var _array = __webpack_require__(22);

var _bem = __webpack_require__(23);

var _bem2 = _interopRequireDefault(_bem);

var _scroll = __webpack_require__(24);

var _string = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.bem = _bem2.default;
exports.createUniqueId = _string.createUniqueId;
exports.getScrollLeft = _scroll.getScrollLeft;
exports.getScrollTop = _scroll.getScrollTop;
exports.toArray = _array.toArray;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PATHS = {
  START_VIEW: 'START_VIEW',
  EXPLANATION_VIEW: 'EXPLANATION_VIEW',
  QUESTION_VIEW: 'QUESTION_VIEW',
  RESULT_VIEW: 'RESULT_VIEW'
};

var QUESTION_STATES = {
  CURRENT: 'CURRENT',
  CORRECT: 'CORRECT',
  INCORRECT: 'INCORRECT',
  NOT_ANSWERED: 'NOT_ANSWERED'
};

var TIERS = {
  TIER_ONE: 'TIER_ONE',
  TIER_TWO: 'TIER_TWO',
  TIER_THREE: 'TIER_THREE',
  TIER_FOUR: 'TIER_FOUR',
  TIER_FIVE: 'TIER_FIVE',
  TIER_SIX: 'TIER_SIX'
};

exports.PATHS = PATHS;
exports.QUESTION_STATES = QUESTION_STATES;
exports.TIERS = TIERS;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__(0);

var _Button = __webpack_require__(45);

var _Button2 = _interopRequireDefault(_Button);

var _dhUtils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } //  @jsx h

var Button = function Button(_ref) {
  var href = _ref.href,
      onClick = _ref.onClick,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === undefined ? [] : _ref$modifiers,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['href', 'onClick', 'modifiers', 'children']);

  if (!modifiers || modifiers.length === 0) {
    modifiers = ['regular'];
  }
  if (href) {
    return (0, _preact.h)(
      'a',
      _extends({
        'class': ['nrk-button', _dhUtils.bem.apply(undefined, [_Button2.default.button].concat(_toConsumableArray(modifiers)))].join(' '),
        href: href
      }, rest),
      children
    );
  }
  return (0, _preact.h)(
    'button',
    _extends({
      'class': ['nrk-button', _dhUtils.bem.apply(undefined, [_Button2.default.button].concat(_toConsumableArray(modifiers)))].join(' '),
      onClick: onClick
    }, rest),
    children
  );
};

exports.Button = Button;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moreInfo = exports.byline = exports.start = exports.share = exports.caption = exports.result = undefined;

var _result, _share;

var _constants = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIER_ONE = _constants.TIERS.TIER_ONE,
    TIER_TWO = _constants.TIERS.TIER_TWO,
    TIER_THREE = _constants.TIERS.TIER_THREE,
    TIER_FOUR = _constants.TIERS.TIER_FOUR,
    TIER_FIVE = _constants.TIERS.TIER_FIVE,
    TIER_SIX = _constants.TIERS.TIER_SIX;


var result = (_result = {}, _defineProperty(_result, TIER_ONE, {
  title: 'Hvalen døde!',
  subtitle: '',
  whaleCaption: '',
  description: 'Hvalen fikk i seg for mye plast og måtte avlives. Prøv igjen, du!'
}), _defineProperty(_result, TIER_TWO, {
  title: 'Du reddet ikke hvalen!',
  subtitle: '',
  whaleCaption: 'Hval gjør du?',
  description: 'Hvalen fikk i seg plast og ble syk. Skal du klare å redde den må du nok gjøre en større innsats.'
}), _defineProperty(_result, TIER_THREE, {
  title: 'Du reddet ikke hvalen!',
  subtitle: '',
  whaleCaption: 'Hval skjer?!',
  description: 'Hvalen overlevde, men det er fortsatt mer plast i havet enn hva den har godt av. Håper du har lært noe til neste gang.'
}), _defineProperty(_result, TIER_FOUR, {
  title: 'Du reddet ikke hvalen!',
  subtitle: '',
  whaleCaption: 'Hval skjer?!',
  description: 'Hvalen overlevde, men det er fortsatt mer plast i havet enn hva den har godt av. Håper du har lært noe til neste gang.'
}), _defineProperty(_result, TIER_FIVE, {
  title: 'Du reddet hvalen!',
  subtitle: '',
  whaleCaption: 'Hvaldig bra!',
  description: 'Bra innsats! Det er likevel mer plast i havet enn hva den har godt av. Du kan gjøre det enda bedre.'
}), _defineProperty(_result, TIER_SIX, {
  title: 'Du reddet hvalen!',
  subtitle: '',
  whaleCaption: 'Digger deg!',
  description: 'Takket være deg svømmer den nå rundt i plastfritt vann. Fortsett sånn!'
}), _result);

var share = (_share = {}, _defineProperty(_share, TIER_ONE, {
  title: 'Jeg prøvde å redde hvalen fra plastdøden!',
  description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
  image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-one.jpg',
  type: 'article'
}), _defineProperty(_share, TIER_TWO, {
  title: 'Jeg prøvde å redde hvalen fra plastdøden!',
  description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
  image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-two.jpg',
  type: 'article'
}), _defineProperty(_share, TIER_THREE, {
  title: 'Jeg prøvde å redde hvalen fra plastdøden!',
  description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
  image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-three.jpg',
  type: 'article'
}), _defineProperty(_share, TIER_FOUR, {
  title: 'Jeg prøvde å redde hvalen fra plastdøden!',
  description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
  image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-four.jpg',
  type: 'article'
}), _defineProperty(_share, TIER_FIVE, {
  title: 'Jeg reddet nesten hvalen fra plastdøden!',
  description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
  image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-five.jpg',
  type: 'article'
}), _defineProperty(_share, TIER_SIX, {
  title: 'Jeg reddet hvalen fra plastdøden!',
  description: 'Klarer DU det? Test deg selv i NRKs plastquiz.',
  image: 'https://static.nrk.no/dh/module/plast-quiz/share/tier-six.jpg',
  type: 'article'
}), _share);

var caption = {
  correct: 'Riktig!',
  wrong: 'Feil!'
};

var start = {
  titlePartOne: 'Redd',
  titlePartTwo: 'hvalen!',
  description: ['Klarer du å redde hvalen fra plastdøden?'],
  startButton: 'Start'
};

var moreInfo = {
  text: 'Se Planet Plast',
  href: 'https://tv.nrk.no/serie/planet-plast'
};

var byline = {
  title: 'Laget av',
  content: [{
    title: 'Digital historieutvikling',
    people: ['Mari Grafsrønningen', 'Kari Anne Gisetstad Andersen', 'Stian Lund Johansen', 'Ragnar Aasen Rognstad']
  }, {
    title: 'Dokumentar og samfunn',
    people: ['Kent-Amar Eriksen', 'Halvard Jakobsen', 'Kim Jansson']
  }, {
    title: 'Ansvarlig redaktør',
    people: ['Frank Gander']
  }]
};

exports.result = result;
exports.caption = caption;
exports.share = share;
exports.start = start;
exports.byline = byline;
exports.moreInfo = moreInfo;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusOnEnter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _index = __webpack_require__(48);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var FocusOnEnter = function (_Component) {
  _inherits(FocusOnEnter, _Component);

  function FocusOnEnter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FocusOnEnter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusOnEnter.__proto__ || Object.getPrototypeOf(FocusOnEnter)).call.apply(_ref, [this].concat(args))), _this), _this.rootEl = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FocusOnEnter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.rootEl) {
        this.rootEl.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return (0, _preact.h)(
        'div',
        {
          // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
          tabIndex: '-1',
          ref: function ref(el) {
            _this2.rootEl = el;
          },
          'class': this.props.class ? this.props.class : _index2.default['focus-on-enter']
        },
        this.props.children
      );
    }
  }]);

  return FocusOnEnter;
}(_preact.Component);

exports.FocusOnEnter = FocusOnEnter;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = undefined;

var _preact = __webpack_require__(0);

var _Box = __webpack_require__(49);

var _Box2 = _interopRequireDefault(_Box);

var _dhUtils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Box = function Box(props) {
  return (0, _preact.h)(
    'div',
    { 'class': (0, _dhUtils.bem)(_Box2.default.box, { 'appear-late': props.appearLate }) },
    props.children
  );
}; //  @jsx h

exports.Box = Box;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"dh-dh-plast-quiz-root","root--has-touch":"dh-dh-plast-quiz-root--has-touch","app--is-android-app":"dh-dh-plast-quiz-app--is-android-app","app":"dh-dh-plast-quiz-app"};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connect = exports.Provider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var Provider = function (_Component) {
  _inherits(Provider, _Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return { __CTX__: props };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children[0];
    }
  }]);

  return Provider;
}(_preact.Component);

Provider.displayName = 'Provider';

function connect(mapContextToProps) {
  return function (wrappedComponent) {
    var Connected = function (_Component2) {
      _inherits(Connected, _Component2);

      function Connected() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, Connected);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = Connected.__proto__ || Object.getPrototypeOf(Connected)).call.apply(_ref, [this].concat(args))), _this2), _this2.mapContextToProps = function (ctx) {
          return mapContextToProps ? mapContextToProps(ctx) : ctx;
        }, _temp), _possibleConstructorReturn(_this2, _ret);
      }

      _createClass(Connected, [{
        key: 'render',
        value: function render() {
          return (0, _preact.h)(wrappedComponent, _extends({}, this.mapContextToProps(this.context['__CTX__']), this.props));
        }
      }]);

      return Connected;
    }(_preact.Component);

    Connected.displayName = 'connect(' + (wrappedComponent.displayName || wrappedComponent.name || 'Component') + ')';
    return Connected;
  };
}

exports.Provider = Provider;
exports.connect = connect;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imagePaths = undefined;

var _imagePaths;

var _constants = __webpack_require__(2);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TIER_ONE = _constants.TIERS.TIER_ONE,
    TIER_TWO = _constants.TIERS.TIER_TWO,
    TIER_THREE = _constants.TIERS.TIER_THREE,
    TIER_FOUR = _constants.TIERS.TIER_FOUR,
    TIER_FIVE = _constants.TIERS.TIER_FIVE,
    TIER_SIX = _constants.TIERS.TIER_SIX;


var imagePaths = (_imagePaths = {}, _defineProperty(_imagePaths, TIER_ONE, 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-one.png'), _defineProperty(_imagePaths, TIER_TWO, 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-two.png'), _defineProperty(_imagePaths, TIER_THREE, 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-three.png'), _defineProperty(_imagePaths, TIER_FOUR, 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-four.png'), _defineProperty(_imagePaths, TIER_FIVE, 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-five.png'), _defineProperty(_imagePaths, TIER_SIX, 'https://static.nrk.no/dh/module/plast-quiz/whales/v3/tier-six.png'), _imagePaths);

exports.imagePaths = imagePaths;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTier = getTier;

var _constants = __webpack_require__(2);

function getTier(numberOfCorrect) {
  var TIER_ONE = _constants.TIERS.TIER_ONE,
      TIER_TWO = _constants.TIERS.TIER_TWO,
      TIER_THREE = _constants.TIERS.TIER_THREE,
      TIER_FOUR = _constants.TIERS.TIER_FOUR,
      TIER_FIVE = _constants.TIERS.TIER_FIVE,
      TIER_SIX = _constants.TIERS.TIER_SIX;

  switch (numberOfCorrect) {
    case 1:
    case 2:
      return TIER_ONE;
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
    case 8:
      return TIER_TWO;
    case 9:
    case 10:
    case 11:
    case 12:
      return TIER_THREE;
    case 13:
    case 14:
    case 15:
      return TIER_FOUR;
    case 16:
    case 17:
    case 18:
      return TIER_FIVE;
    case 19:
    case 20:
      return TIER_SIX;
    default:
      return TIER_ONE;
  }
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _matches = __webpack_require__(69);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var Router = function (_Component) {
  _inherits(Router, _Component);

  function Router() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Router.__proto__ || Object.getPrototypeOf(Router)).call.apply(_ref, [this].concat(args))), _this), _this.getCurrentChildren = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          path = _this$props.path;

      var matchingChildren = children.filter(function (child) {
        var attributes = child.attributes;

        if (attributes && attributes.path) {
          if (Array.isArray(attributes.path)) {
            return _matches.matches.apply(undefined, [path].concat(_toConsumableArray(attributes.path)));
          }
          return (0, _matches.matches)(path, attributes.path);
        }
        return false;
      });

      if (matchingChildren.length) {
        return matchingChildren;
      }

      var defaultChildren = children.filter(function (child) {
        return child.attributes && child.attributes.default;
      });

      return defaultChildren;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Router, [{
    key: 'render',
    value: function render() {
      var multiple = this.props.multiple;

      var currentChildren = this.getCurrentChildren();
      if (multiple) {
        return (0, _preact.h)(
          'div',
          null,
          currentChildren
        );
      }
      return currentChildren[0] || null;
    }
  }]);

  return Router;
}(_preact.Component);

exports.Router = Router;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(14);
module.exports = __webpack_require__(20);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(15);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _index = __webpack_require__(16);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var global = function () {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
}();

if (!global.Promise) {
  global.Promise = _index2.default;
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function () {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function () {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
    if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function () {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(function (value) {
      if (done) return;
      done = true;
      resolve(self, value);
    }, function (reason) {
      if (done) return;
      done = true;
      reject(self, reason);
    });
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function (onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function (callback) {
  var constructor = this.constructor;
  return this.then(function (value) {
    return constructor.resolve(callback()).then(function () {
      return value;
    });
  }, function (reason) {
    return constructor.resolve(callback()).then(function () {
      return constructor.reject(reason);
    });
  });
};

Promise.all = function (arr) {
  return new Promise(function (resolve, reject) {
    if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(val, function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function (value) {
  if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function (resolve) {
    resolve(value);
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
  setImmediate(fn);
} || function (fn) {
  setTimeoutFunc(fn, 0);
};

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

exports.default = Promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17).setImmediate))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(18);
// On some exotic environments, it's not clear which object `setimmeidate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(19)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _domready = __webpack_require__(21);

var _domready2 = _interopRequireDefault(_domready);

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _errorReporting = __webpack_require__(26);

var _App = __webpack_require__(28);

var _App2 = __webpack_require__(8);

var _App3 = _interopRequireDefault(_App2);

var _dhAnalyticsUtils = __webpack_require__(74);

var _getContextId = __webpack_require__(75);

var _provider = __webpack_require__(9);

var _getGlobalGa = __webpack_require__(76);

var _addTouchClass = __webpack_require__(77);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootElementClassName = _App3.default.root; /* global __HOT__ */
// @jsx h

window[rootElementClassName] = window[rootElementClassName] || {};

function init() {
  findElements(rootElementClassName).forEach(function (el) {
    el.id = (0, _dhUtils.createUniqueId)();
    window[rootElementClassName][el.id] = true;

    // Extract values sent from server
    var name = el.getAttribute('data-name');
    var preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'));
    var errorTrackingEnabled = el.getAttribute('data-error-tracking-enabled') === 'true';

    // setup error reporting
    var simpleErrorReport = (0, _errorReporting.createErrorReporter)(name, errorTrackingEnabled);
    simpleErrorReport.listenAndCatch();

    // Extract metadata required to create google analytics tracker
    var gaPropertyId = el.getAttribute('data-ga-property-id');
    var metadata = JSON.parse(el.getAttribute('data-metadata'));
    var title = metadata.title,
        selfId = metadata.selfId,
        published = metadata.published;


    (0, _addTouchClass.addTouchClass)(el, _App3.default['root--has-touch']);

    // create google analytics tracker
    var googleAnalyticsTracker = (0, _dhAnalyticsUtils.createGoogleAnalyticsTracker)((0, _getGlobalGa.getGlobalGa)(), {
      name: 'dh',
      gaPropertyId: gaPropertyId,
      self: {
        id: selfId,
        title: title,
        publishedDate: published ? new Date(published) : null
      },
      context: {
        id: (0, _getContextId.getContextId)(document.location.href)
      }
    });

    var sendError = function sendError(message) {
      simpleErrorReport.sendErrorReport({ message: message });
    };

    var sendGaEvent = function sendGaEvent(action) {
      googleAnalyticsTracker.sendEvent({
        category: 'dh-spesialmodul',
        label: name,
        action: action
      });
    };

    // ... and render with the exact same props as on server
    (0, _preact.render)((0, _preact.h)(
      _provider.Provider,
      { sendGaEvent: sendGaEvent, sendError: sendError },
      (0, _preact.h)(_App.App, preloadedState)
    ), el, el.firstChild);

    // track load event
    sendGaEvent('load');

    // Enable webpack hot-reloading
    if (false) {
      // Reload and re-render preact application
      module.hot.accept('./client', function () {
        var _require = require('./components/App'),
            App = _require.App;

        var _require2 = require('../lib/provider'),
            CustomProvider = _require2.Provider;

        (0, _preact.render)((0, _preact.h)(
          CustomProvider,
          { sendGaEvent: sendGaEvent, sendError: sendError },
          (0, _preact.h)(App, preloadedState)
        ), el, el.firstChild);
      });
    }
  });
}

if (false) {
  require('preact/debug');
}

function findElements(className) {
  return (0, _dhUtils.toArray)(document.getElementsByClassName(className)).filter(function (el) {
    return !isInitialized(el, className);
  });
}

function isInitialized(el, className) {
  return el.id && window[className][el.id];
}

(0, _domready2.default)(init);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition();else if (typeof define == 'function' && _typeof(define.amd) == 'object') define(definition);else this[name] = definition();
}('domready', function () {

  var fns = [],
      _listener,
      doc = document,
      hack = doc.documentElement.doScroll,
      domContentLoaded = 'DOMContentLoaded',
      loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);

  if (!loaded) doc.addEventListener(domContentLoaded, _listener = function listener() {
    doc.removeEventListener(domContentLoaded, _listener);
    loaded = 1;
    while (_listener = fns.shift()) {
      _listener();
    }
  });

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  };
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = toArray;
function toArray(nodeList) {
  return [].slice.call(nodeList);
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

function toStrings(object) {
  return Object.keys(object).filter(function (key) {
    return object[key];
  });
}

exports.default = function (blockName) {
  for (var _len = arguments.length, modifiers = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }

  var strings = modifiers.filter(function (modifier) {
    return typeof modifier === 'string';
  });
  var objects = modifiers.filter(function (modifier) {
    return (typeof modifier === 'undefined' ? 'undefined' : _typeof(modifier)) === 'object';
  });

  var objectString = objects.map(function (object) {
    return toStrings(object);
  }).reduce(function (a, b) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(b));
  }, []);

  return [blockName].concat(strings.map(function (modifier) {
    return blockName + '--' + modifier;
  })).concat(objectString.map(function (modifier) {
    return blockName + '--' + modifier;
  })).join(' ');
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollLeft = getScrollLeft;
exports.getScrollTop = getScrollTop;
function getScrollLeft() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || 0;
}

function getScrollTop() {
  if (typeof window === 'undefined') {
    return 0;
  }

  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || 0;
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUniqueId = createUniqueId;
function createUniqueId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '' + prefix + Math.random().toString(36).substr(2, len - prefix.length);
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorReporter = createErrorReporter;

var _dhSimpleErrorReport = __webpack_require__(27);

function createErrorReporter(name, isErrorReportingEnabled) {
  return new _dhSimpleErrorReport.SimpleErrorReport({
    name: name,
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  });
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["simple-error-report"] = {});
}(undefined, function (e) {
  "use strict";
  var n = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var r = function () {
    function e() {
      !function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.register = [];
    }return n(e, [{ key: "addErrorToRegister", value: function value(e) {
        this.register.push({ time: new Date(), message: e });
      } }, { key: "isInRegisterWithinRange", value: function value(e, n) {
        return this.register.filter(function (r) {
          return r.message === e && new Date() - r.time < n;
        }).length > 0;
      } }]), e;
  }(),
      t = function () {
    function e(e, n) {
      for (var r = 0; r < n.length; r++) {
        var t = n[r];t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, t.key, t);
      }
    }return function (n, r, t) {
      return r && e(n.prototype, r), t && e(n, t), n;
    };
  }();var i = [],
      o = function () {
    function e(n) {
      var t = n.name,
          o = n.url,
          s = n.dryRun,
          a = void 0 === s || s;!function (e, n) {
        if (!(e instanceof n)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.name = t, this.url = o, this.errorRegister = new r(), this.dryRun = a, i.push(this.name);
    }return t(e, [{ key: "listenAndCatch", value: function value() {
        var e = this;i.length <= 1 && (window.addEventListener("error", function (n) {
          var r = n.message,
              t = n.filename,
              i = n.lineno,
              o = n.colno,
              s = { message: r };"" !== t && (s.url = t), i > 0 && (s.line = i), o > 0 && (s.column = o), e.sendErrorReport(s);
        }), window.addEventListener("unhandledrejection", function (n) {
          e.sendErrorReport({ message: "Unhandled Promise Rejection: " + n.reason });
        }));
      } }, { key: "sendErrorReport", value: function value(e) {
        var n, r, t;this.dryRun ? "undefined" != typeof console && console.log("Dry run: " + JSON.stringify(e)) : this.errorRegister.isInRegisterWithinRange(e.message, 500) || (this.errorRegister.addErrorToRegister(e.message), n = this.url + "/" + this.name, r = e, (t = new XMLHttpRequest()).open("POST", n), t.setRequestHeader("Content-Type", "application/json"), t.send(JSON.stringify(r)));
      } }]), e;
  }();e.SimpleErrorReport = o, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _App = __webpack_require__(8);

var _App2 = _interopRequireDefault(_App);

var _provider = __webpack_require__(9);

var _dhUtils = __webpack_require__(1);

var _Background = __webpack_require__(29);

var _StartView = __webpack_require__(44);

var _ResultView = __webpack_require__(47);

var _ExplanationView = __webpack_require__(51);

var _QuestionView = __webpack_require__(53);

var _Foreground = __webpack_require__(59);

var _Overlay = __webpack_require__(61);

var _Modal = __webpack_require__(70);

var _Router = __webpack_require__(12);

var _Fullscreen = __webpack_require__(72);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var START_VIEW = _constants.PATHS.START_VIEW,
    EXPLANATION_VIEW = _constants.PATHS.EXPLANATION_VIEW,
    QUESTION_VIEW = _constants.PATHS.QUESTION_VIEW,
    RESULT_VIEW = _constants.PATHS.RESULT_VIEW;


var initialState = {
  path: START_VIEW,
  questionNumber: 0,
  answers: [],
  isModalShowing: false,
  isAndroidApp: false
};

var AppComponent = function (_Component) {
  _inherits(AppComponent, _Component);

  function AppComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, initialState), _this.toggleModal = function () {
      _this.setState({ isModalShowing: !_this.state.isModalShowing });
    }, _this.restart = function () {
      _this.setState(_extends({}, initialState, { path: START_VIEW }));
    }, _this.onAnswerClick = function (isCorrectAnswer) {
      var _this$props = _this.props,
          sendGaEvent = _this$props.sendGaEvent,
          questions = _this$props.questions;
      var _this$state = _this.state,
          questionNumber = _this$state.questionNumber,
          answers = _this$state.answers;


      _this.setState({
        path: EXPLANATION_VIEW,
        answers: answers.concat([{
          questionNumber: questionNumber,
          correct: isCorrectAnswer
        }])
      });

      sendGaEvent('ANSWER/' + questions[questionNumber].description + '/' + (isCorrectAnswer ? 'correct' : 'wrong'));
    }, _this.onNextClick = function () {
      var _this$state2 = _this.state,
          questionNumber = _this$state2.questionNumber,
          answers = _this$state2.answers;
      var _this$props2 = _this.props,
          questions = _this$props2.questions,
          sendGaEvent = _this$props2.sendGaEvent;

      var questionsLength = questions.length;
      var answersLength = answers.length;
      var finishedQuiz = questionsLength === answersLength;
      var numberOfCorrect = answers.filter(function (answer) {
        return answer.correct;
      }).length;

      _this.setState({
        questionNumber: questionNumber + 1,
        path: finishedQuiz ? RESULT_VIEW : QUESTION_VIEW
      });

      sendGaEvent('NEXT/' + questions[questionNumber].description);
      if (finishedQuiz) {
        sendGaEvent('RESULT/' + numberOfCorrect);
      }
    }, _this.onStartClick = function () {
      _this.props.sendGaEvent('START_QUIZ');
      _this.setState({
        path: QUESTION_VIEW
      });
    }, _this.onShareClick = function (e) {
      e.preventDefault();
      _this.props.sendGaEvent('SHARE');
      var elm = e.target;
      window.open(elm.getAttribute('href'), elm.getAttribute('target'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        isAndroidApp: location.search.indexOf('viewContext=no.nrk.mobil.app') > -1
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var questions = this.props.questions;
      var _state = this.state,
          questionNumber = _state.questionNumber,
          answers = _state.answers,
          path = _state.path,
          isModalShowing = _state.isModalShowing,
          isAndroidApp = _state.isAndroidApp;

      var currentQuestion = questions[questionNumber];

      var positionOrigo = questions.length;
      var currentPosition = answers.reduce(function (pv, cv) {
        return cv.correct ? pv + 1 : pv - 1;
      }, positionOrigo);
      var maxScore = questions.length * 2;
      var isCorrect = wasCorrect(answers);

      return (0, _preact.h)(
        _Fullscreen.Fullscreen,
        { 'class': (0, _dhUtils.bem)(_App2.default.app, { 'is-android-app': isAndroidApp }) },
        (0, _preact.h)(_Background.Background, {
          currentPosition: currentPosition,
          maxScore: maxScore,
          isCorrect: isCorrect,
          isCaptionVisible: path === EXPLANATION_VIEW,
          isResultView: path === RESULT_VIEW,
          answers: answers
        }),
        (0, _preact.h)(
          _Foreground.Foreground,
          {
            centered: [START_VIEW].indexOf(path) > -1,
            ariaHidden: isModalShowing
          },
          (0, _preact.h)(
            _Router.Router,
            { path: path },
            (0, _preact.h)(_StartView.StartView, { path: START_VIEW, onStartClick: this.onStartClick }),
            (0, _preact.h)(_ResultView.ResultView, {
              path: RESULT_VIEW,
              answers: answers,
              currentPosition: currentPosition,
              onShareClick: this.onShareClick
            }),
            (0, _preact.h)(_QuestionView.QuestionView, {
              path: QUESTION_VIEW,
              currentQuestion: currentQuestion,
              onAnswerClick: this.onAnswerClick
            }),
            (0, _preact.h)(_ExplanationView.ExplanationView, {
              path: EXPLANATION_VIEW,
              currentQuestion: currentQuestion,
              isCorrect: isCorrect,
              onNextClick: this.onNextClick
            })
          )
        ),
        (0, _preact.h)(_Overlay.Overlay, {
          questions: questions,
          questionNumber: questionNumber,
          answers: answers,
          path: path,
          toggleModal: this.toggleModal,
          restart: this.restart,
          ariaHidden: isModalShowing
        }),
        (0, _preact.h)(_Modal.Modal, { isShowing: isModalShowing, toggleModal: this.toggleModal })
      );
    }
  }]);

  return AppComponent;
}(_preact.Component);

var App = exports.App = (0, _provider.connect)()(AppComponent);

function wasCorrect(answers) {
  var lastAnswer = answers[answers.length - 1];
  if (!lastAnswer) return false;

  return answers[answers.length - 1].correct;
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Background = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _Sea = __webpack_require__(30);

var _Trash = __webpack_require__(32);

var _Whale = __webpack_require__(34);

var _Light = __webpack_require__(36);

var _Overlay = __webpack_require__(38);

var _WhaleCaption = __webpack_require__(40);

var _WhaleImagesLoader = __webpack_require__(42);

var _getTier = __webpack_require__(11);

var _index = __webpack_require__(43);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var Background = function (_Component) {
  _inherits(Background, _Component);

  function Background() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Background);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Background.__proto__ || Object.getPrototypeOf(Background)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isWhaleReady: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Background, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          isWhaleReady: true
        });
      }, 500);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          maxScore = _props.maxScore,
          currentPosition = _props.currentPosition,
          isCaptionVisible = _props.isCaptionVisible,
          isResultView = _props.isResultView,
          isCorrect = _props.isCorrect,
          answers = _props.answers;
      var isWhaleReady = this.state.isWhaleReady;

      var positionPercentage = currentPosition / maxScore * 100;
      var currentTier = (0, _getTier.getTier)(currentPosition);

      return (0, _preact.h)(
        'div',
        { 'class': _index2.default.background, 'aria-hidden': true },
        (0, _preact.h)(_Sea.Sea, { currentTier: currentTier }),
        (0, _preact.h)(_Trash.TrashLayer, { index: 1, positionPercentage: positionPercentage }),
        (0, _preact.h)(_Trash.TrashLayer, { index: 2, positionPercentage: positionPercentage }),
        (0, _preact.h)(_WhaleImagesLoader.WhaleImagesLoader, null),
        isWhaleReady && (0, _preact.h)(
          _Whale.Whale,
          { currentTier: currentTier },
          (0, _preact.h)(_WhaleCaption.WhaleCaption, {
            isResultView: isResultView,
            isVisible: isCaptionVisible || isResultView,
            isCorrect: isCorrect,
            answers: answers,
            currentTier: currentTier
          })
        ),
        (0, _preact.h)(_Trash.TrashLayer, { index: 3, positionPercentage: positionPercentage }),
        (0, _preact.h)(_Light.Light, null),
        (0, _preact.h)(_Overlay.Overlay, { currentTier: currentTier })
      );
    }
  }]);

  return Background;
}(_preact.Component);

exports.Background = Background;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sea = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _Sea = __webpack_require__(31);

var _Sea2 = _interopRequireDefault(_Sea);

var _dhUtils = __webpack_require__(1);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var TIER_ONE = _constants.TIERS.TIER_ONE,
    TIER_TWO = _constants.TIERS.TIER_TWO,
    TIER_THREE = _constants.TIERS.TIER_THREE,
    TIER_FOUR = _constants.TIERS.TIER_FOUR,
    TIER_FIVE = _constants.TIERS.TIER_FIVE,
    TIER_SIX = _constants.TIERS.TIER_SIX;

var Sea = function (_Component) {
  _inherits(Sea, _Component);

  function Sea() {
    _classCallCheck(this, Sea);

    return _possibleConstructorReturn(this, (Sea.__proto__ || Object.getPrototypeOf(Sea)).apply(this, arguments));
  }

  _createClass(Sea, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.currentTier !== this.props.currentTier;
    }
  }, {
    key: 'render',
    value: function render() {
      var currentTier = this.props.currentTier;

      var modifiers = {
        darkest: currentTier === TIER_ONE,
        'extra-dark': currentTier === TIER_TWO,
        dark: currentTier === TIER_THREE,
        light: currentTier === TIER_FOUR,
        'extra-light': currentTier === TIER_FIVE,
        lightest: currentTier === TIER_SIX
      };
      return (0, _preact.h)(
        'div',
        { 'class': (0, _dhUtils.bem)(_Sea2.default.sea, modifiers) },
        (0, _preact.h)('div', { 'class': _Sea2.default['sea-waves'] })
      );
    }
  }]);

  return Sea;
}(_preact.Component);

exports.Sea = Sea;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"sea":"dh-dh-plast-quiz-sea","sea--darkest":"dh-dh-plast-quiz-sea--darkest","sea--extra-dark":"dh-dh-plast-quiz-sea--extra-dark","sea--dark":"dh-dh-plast-quiz-sea--dark","sea--light":"dh-dh-plast-quiz-sea--light","sea--extra-light":"dh-dh-plast-quiz-sea--extra-light","sea--lightest":"dh-dh-plast-quiz-sea--lightest","sea-waves":"dh-dh-plast-quiz-sea-waves","move":"dh-dh-plast-quiz-move"};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrashLayer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _Trash = __webpack_require__(33);

var _Trash2 = _interopRequireDefault(_Trash);

var _dhUtils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var TrashLayer = function (_Component) {
  _inherits(TrashLayer, _Component);

  function TrashLayer() {
    _classCallCheck(this, TrashLayer);

    return _possibleConstructorReturn(this, (TrashLayer.__proto__ || Object.getPrototypeOf(TrashLayer)).apply(this, arguments));
  }

  _createClass(TrashLayer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          index = _props.index,
          positionPercentage = _props.positionPercentage;


      return (0, _preact.h)(
        'div',
        {
          'class': _Trash2.default.trash,
          style: percentageToTransfrom(positionPercentage)
        },
        (0, _preact.h)(
          'div',
          { 'class': (0, _dhUtils.bem)(_Trash2.default['trash__layer'], String(index)) },
          (0, _preact.h)('div', { 'class': (0, _dhUtils.bem)(_Trash2.default['trash__layer-top'], String(index)) }),
          (0, _preact.h)('div', { 'class': (0, _dhUtils.bem)(_Trash2.default['trash__layer-bottom'], String(index)) })
        )
      );
    }
  }]);

  return TrashLayer;
}(_preact.Component);

function percentageToTransfrom(percentage) {
  var removeEntirely = percentage > 95;
  var translation = removeEntirely ? 105 : Math.max(5, Math.min(percentage, 95));
  var transform = 'translateY(' + translation + '%)';
  return {
    WebkitTransform: transform,
    transform: transform
  };
}

exports.TrashLayer = TrashLayer;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"trash":"dh-dh-plast-quiz-trash","trash__layer":"dh-dh-plast-quiz-trash__layer","trash__layer-top":"dh-dh-plast-quiz-trash__layer-top","trash__layer-bottom":"dh-dh-plast-quiz-trash__layer-bottom","trash__layer-bottom--1":"dh-dh-plast-quiz-trash__layer-bottom--1","trash__layer-top--1":"dh-dh-plast-quiz-trash__layer-top--1","trash__layer-bottom--2":"dh-dh-plast-quiz-trash__layer-bottom--2","trash__layer-top--2":"dh-dh-plast-quiz-trash__layer-top--2","trash__layer-bottom--3":"dh-dh-plast-quiz-trash__layer-bottom--3","trash__layer-top--3":"dh-dh-plast-quiz-trash__layer-top--3","trash__layer--1":"dh-dh-plast-quiz-trash__layer--1","trash__layer--2":"dh-dh-plast-quiz-trash__layer--2","trash__layer--3":"dh-dh-plast-quiz-trash__layer--3","trash-float":"dh-dh-plast-quiz-trash-float","trash-opacity":"dh-dh-plast-quiz-trash-opacity"};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Whale = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _constants = __webpack_require__(2);

var _images = __webpack_require__(10);

var _Whale = __webpack_require__(35);

var _Whale2 = _interopRequireDefault(_Whale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var TIER_ONE = _constants.TIERS.TIER_ONE,
    TIER_TWO = _constants.TIERS.TIER_TWO,
    TIER_THREE = _constants.TIERS.TIER_THREE,
    TIER_FOUR = _constants.TIERS.TIER_FOUR,
    TIER_FIVE = _constants.TIERS.TIER_FIVE,
    TIER_SIX = _constants.TIERS.TIER_SIX;

var Whale = function (_Component) {
  _inherits(Whale, _Component);

  function Whale() {
    _classCallCheck(this, Whale);

    return _possibleConstructorReturn(this, (Whale.__proto__ || Object.getPrototypeOf(Whale)).apply(this, arguments));
  }

  _createClass(Whale, [{
    key: 'render',
    value: function render() {
      var currentTier = this.props.currentTier;

      var modifiers = {
        dead: currentTier === TIER_ONE,
        'extra-sad': currentTier === TIER_TWO,
        sad: currentTier === TIER_THREE,
        happy: currentTier === TIER_FOUR,
        'extra-happy': currentTier === TIER_FIVE,
        saved: currentTier === TIER_SIX
      };

      return (0, _preact.h)(
        'div',
        { 'class': (0, _dhUtils.bem)(_Whale2.default.whale__wrapper) },
        (0, _preact.h)(
          'div',
          { 'class': (0, _dhUtils.bem)(_Whale2.default['whale__swim-wrapper'], modifiers) },
          this.props.children,
          (0, _preact.h)(
            'div',
            { 'class': (0, _dhUtils.bem)(_Whale2.default.whale) },
            (0, _preact.h)('img', {
              alt: '',
              src: _images.imagePaths[currentTier],
              'class': (0, _dhUtils.bem)(_Whale2.default.whale__image)
            })
          )
        )
      );
    }
  }]);

  return Whale;
}(_preact.Component);

exports.Whale = Whale;

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"whale__wrapper":"dh-dh-plast-quiz-whale__wrapper","swim-outer":"dh-dh-plast-quiz-swim-outer","whale__swim-wrapper":"dh-dh-plast-quiz-whale__swim-wrapper","swim":"dh-dh-plast-quiz-swim","whale__swim-wrapper--dead":"dh-dh-plast-quiz-whale__swim-wrapper--dead","whale__swim-wrapper--extra-sad":"dh-dh-plast-quiz-whale__swim-wrapper--extra-sad","whale__swim-wrapper--sad":"dh-dh-plast-quiz-whale__swim-wrapper--sad","whale__swim-wrapper--happy":"dh-dh-plast-quiz-whale__swim-wrapper--happy","whale__swim-wrapper--extra-happy":"dh-dh-plast-quiz-whale__swim-wrapper--extra-happy","whale__swim-wrapper--saved":"dh-dh-plast-quiz-whale__swim-wrapper--saved","whale":"dh-dh-plast-quiz-whale","whale-direction":"dh-dh-plast-quiz-whale-direction","whale__image":"dh-dh-plast-quiz-whale__image","whale__image--hidden":"dh-dh-plast-quiz-whale__image--hidden","whale--sad":"dh-dh-plast-quiz-whale--sad","rotate":"dh-dh-plast-quiz-rotate"};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Light = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _Light = __webpack_require__(37);

var _Light2 = _interopRequireDefault(_Light);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var Light = function (_Component) {
  _inherits(Light, _Component);

  function Light() {
    _classCallCheck(this, Light);

    return _possibleConstructorReturn(this, (Light.__proto__ || Object.getPrototypeOf(Light)).apply(this, arguments));
  }

  _createClass(Light, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _preact.h)('div', { 'class': _Light2.default.light });
    }
  }]);

  return Light;
}(_preact.Component);

exports.Light = Light;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"light":"dh-dh-plast-quiz-light"};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _Overlay = __webpack_require__(39);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _dhUtils = __webpack_require__(1);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var TIER_ONE = _constants.TIERS.TIER_ONE,
    TIER_TWO = _constants.TIERS.TIER_TWO,
    TIER_THREE = _constants.TIERS.TIER_THREE,
    TIER_FOUR = _constants.TIERS.TIER_FOUR,
    TIER_FIVE = _constants.TIERS.TIER_FIVE,
    TIER_SIX = _constants.TIERS.TIER_SIX;

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  function Overlay() {
    _classCallCheck(this, Overlay);

    return _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).apply(this, arguments));
  }

  _createClass(Overlay, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.currentTier !== this.props.currentTier;
    }
  }, {
    key: 'render',
    value: function render() {
      var currentTier = this.props.currentTier;

      var modifiers = {
        darkest: currentTier === TIER_ONE,
        'extra-dark': currentTier === TIER_TWO,
        dark: currentTier === TIER_THREE,
        light: currentTier === TIER_FOUR,
        'extra-light': currentTier === TIER_FIVE,
        lightest: currentTier === TIER_SIX
      };
      return (0, _preact.h)('div', { 'class': (0, _dhUtils.bem)(_Overlay2.default['background-overlay'], modifiers) });
    }
  }]);

  return Overlay;
}(_preact.Component);

exports.Overlay = Overlay;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"background-overlay":"dh-dh-plast-quiz-background-overlay","background-overlay--darkest":"dh-dh-plast-quiz-background-overlay--darkest","background-overlay--extra-dark":"dh-dh-plast-quiz-background-overlay--extra-dark","background-overlay--dark":"dh-dh-plast-quiz-background-overlay--dark","background-overlay--light":"dh-dh-plast-quiz-background-overlay--light","background-overlay--extra-light":"dh-dh-plast-quiz-background-overlay--extra-light","background-overlay--lightest":"dh-dh-plast-quiz-background-overlay--lightest"};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhaleCaption = undefined;

var _preact = __webpack_require__(0);

var _WhaleCaption = __webpack_require__(41);

var _WhaleCaption2 = _interopRequireDefault(_WhaleCaption);

var _dhUtils = __webpack_require__(1);

var _text = __webpack_require__(4);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIER_ONE = _constants.TIERS.TIER_ONE; //  @jsx h

var WhaleCaption = function WhaleCaption(_ref) {
  var isCorrect = _ref.isCorrect,
      isVisible = _ref.isVisible,
      isResultView = _ref.isResultView,
      answers = _ref.answers,
      currentTier = _ref.currentTier;

  var text = isCorrect ? _text.caption.correct : _text.caption.wrong;
  if (isResultView) {
    var whaleCaption = _text.result[currentTier].whaleCaption;

    text = whaleCaption;
  }
  return (0, _preact.h)(
    'div',
    { 'class': _WhaleCaption2.default['whale-caption__wrapper'] },
    (0, _preact.h)(
      'div',
      {
        'class': (0, _dhUtils.bem)(_WhaleCaption2.default['whale-caption'], {
          visible: currentTier !== TIER_ONE && isVisible
        })
      },
      (0, _preact.h)(
        'span',
        { 'class': _WhaleCaption2.default['whale-caption__text'] },
        text
      )
    )
  );
};

exports.WhaleCaption = WhaleCaption;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"whale-caption__wrapper":"dh-dh-plast-quiz-whale-caption__wrapper","whale-caption":"dh-dh-plast-quiz-whale-caption","whale-caption--visible":"dh-dh-plast-quiz-whale-caption--visible","whale-caption__text":"dh-dh-plast-quiz-whale-caption__text"};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhaleImagesLoader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _constants = __webpack_require__(2);

var _images = __webpack_require__(10);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var WhaleImagesLoader = function (_Component) {
  _inherits(WhaleImagesLoader, _Component);

  function WhaleImagesLoader() {
    _classCallCheck(this, WhaleImagesLoader);

    return _possibleConstructorReturn(this, (WhaleImagesLoader.__proto__ || Object.getPrototypeOf(WhaleImagesLoader)).apply(this, arguments));
  }

  _createClass(WhaleImagesLoader, [{
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        'div',
        { style: { display: 'none' } },
        Object.keys(_constants.TIERS).map(function (tier) {
          return (0, _preact.h)('img', { key: 'image-loader-' + tier, alt: '', src: _images.imagePaths[tier] });
        })
      );
    }
  }]);

  return WhaleImagesLoader;
}(_preact.Component);

exports.WhaleImagesLoader = WhaleImagesLoader;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"background":"dh-dh-plast-quiz-background"};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StartView = undefined;

var _preact = __webpack_require__(0);

var _Button = __webpack_require__(3);

var _StartView = __webpack_require__(46);

var _StartView2 = _interopRequireDefault(_StartView);

var _dhUtils = __webpack_require__(1);

var _text = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var titlePartOne = _text.start.titlePartOne,
    titlePartTwo = _text.start.titlePartTwo,
    description = _text.start.description,
    startButton = _text.start.startButton; //  @jsx h

var StartView = function StartView(_ref) {
  var onStartClick = _ref.onStartClick;

  return (0, _preact.h)(
    'div',
    { 'class': _StartView2.default.start },
    (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'h1',
        {
          'class': _StartView2.default.start__heading,
          'aria-label': titlePartOne + ' ' + titlePartTwo
        },
        (0, _preact.h)(
          'span',
          { 'class': (0, _dhUtils.bem)(_StartView2.default['start__heading-span'], 'small') },
          titlePartOne,
          ' '
        ),
        (0, _preact.h)(
          'span',
          { 'class': (0, _dhUtils.bem)(_StartView2.default['start__heading-span'], 'large') },
          titlePartTwo
        )
      ),
      (0, _preact.h)(
        'p',
        { 'class': _StartView2.default.start__desc },
        description.map(function (content) {
          return (0, _preact.h)(
            'span',
            { key: content, 'class': (0, _dhUtils.bem)(_StartView2.default['start__desc-span']) },
            content,
            ' '
          );
        })
      )
    ),
    (0, _preact.h)(
      _Button.Button,
      {
        modifiers: ['inverted', 'slim', 'bold', 'start'],
        onClick: onStartClick
      },
      startButton
    )
  );
};

exports.StartView = StartView;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button":"dh-dh-plast-quiz-button","root--has-touch":"dh-dh-plast-quiz-root--has-touch","box":"dh-dh-plast-quiz-box","button--regular":"dh-dh-plast-quiz-button--regular","modal":"dh-dh-plast-quiz-modal","button--inverted":"dh-dh-plast-quiz-button--inverted","button--start":"dh-dh-plast-quiz-button--start","button--icon":"dh-dh-plast-quiz-button--icon","button--with-icon":"dh-dh-plast-quiz-button--with-icon","button--with-icon-right":"dh-dh-plast-quiz-button--with-icon-right","button--slim":"dh-dh-plast-quiz-button--slim","button--border":"dh-dh-plast-quiz-button--border","button--bold":"dh-dh-plast-quiz-button--bold"};

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"start":"dh-dh-plast-quiz-start","start__heading":"dh-dh-plast-quiz-start__heading","start__heading-span":"dh-dh-plast-quiz-start__heading-span","start__heading-span--large":"dh-dh-plast-quiz-start__heading-span--large","start__heading-span--small":"dh-dh-plast-quiz-start__heading-span--small","start__desc":"dh-dh-plast-quiz-start__desc","start__desc-span":"dh-dh-plast-quiz-start__desc-span"};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResultView = undefined;

var _preact = __webpack_require__(0);

var _FocusOnEnter = __webpack_require__(5);

var _Box = __webpack_require__(6);

var _Button = __webpack_require__(3);

var _getTier = __webpack_require__(11);

var _text = __webpack_require__(4);

var _ResultView = __webpack_require__(50);

var _ResultView2 = _interopRequireDefault(_ResultView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResultView = function ResultView(_ref) {
  var answers = _ref.answers,
      currentPosition = _ref.currentPosition,
      onShareClick = _ref.onShareClick;

  var _result$getTier = _text.result[(0, _getTier.getTier)(currentPosition)],
      title = _result$getTier.title,
      description = _result$getTier.description;

  var shareUrl = '';
  if (typeof window !== 'undefined') {
    var metadataUrl = 'https://dh.nrk.no/plast-quiz/v1/api/share/' + currentPosition;
    var redirectUrl = window.location && window.location.href || '';
    var shareApiUrl = 'http://share.nrk.no/api/dele/v2/share';
    var shareUrlParam = encodeURIComponent(shareApiUrl + '?r=' + encodeURIComponent(redirectUrl) + '&m=' + encodeURIComponent(metadataUrl));
    shareUrl = 'https://www.facebook.com/sharer.php?u=' + shareUrlParam;
  }

  return (0, _preact.h)(
    _Box.Box,
    null,
    (0, _preact.h)(
      _FocusOnEnter.FocusOnEnter,
      null,
      (0, _preact.h)(
        'h2',
        null,
        title
      ),
      (0, _preact.h)(
        'p',
        null,
        description
      ),
      (0, _preact.h)(
        'div',
        { 'class': _ResultView2.default['result__button-group'] },
        (0, _preact.h)(
          _Button.Button,
          {
            onClick: onShareClick,
            target: '_blank',
            modifiers: ['with-icon', 'slim'],
            href: shareUrl
          },
          (0, _preact.h)(
            'span',
            { 'aria-hidden': true },
            (0, _preact.h)(
              'svg',
              { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 15 15' },
              (0, _preact.h)('path', { d: 'M8.4 4.6c0-.5 0-.8.8-.8h1V2H8.7C7 2 6.2 3.2 6.2 4.6v1H4.7v2h1.5V13h2.2V7.5H10l.2-1.8H8.4v-1z' })
            )
          ),
          'Del resultat'
        ),
        (0, _preact.h)(
          _Button.Button,
          {
            onClick: onShareClick,
            target: '_blank',
            modifiers: ['with-icon-right', 'read-more', 'slim', 'inverted', 'border'],
            href: _text.moreInfo.href
          },
          _text.moreInfo.text
        )
      )
    )
  );
}; //  @jsx h

exports.ResultView = ResultView;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"focus-on-enter":"dh-dh-plast-quiz-focus-on-enter"};

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"box":"dh-dh-plast-quiz-box","appear-in":"dh-dh-plast-quiz-appear-in","box--appear-late":"dh-dh-plast-quiz-box--appear-late"};

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"result__button-group":"dh-dh-plast-quiz-result__button-group"};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExplanationView = undefined;

var _preact = __webpack_require__(0);

var _Explanation = __webpack_require__(52);

var _Box = __webpack_require__(6);

var ExplanationView = function ExplanationView(_ref) {
  var currentQuestion = _ref.currentQuestion,
      isCorrect = _ref.isCorrect,
      onNextClick = _ref.onNextClick;

  return (0, _preact.h)(
    _Box.Box,
    { appearLate: true },
    (0, _preact.h)(_Explanation.Explanation, {
      wasCorrect: isCorrect,
      explanation: currentQuestion.explanation,
      onNextClick: onNextClick
    })
  );
}; //  @jsx h

exports.ExplanationView = ExplanationView;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Explanation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _Button = __webpack_require__(3);

var _FocusOnEnter = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h


var Explanation = exports.Explanation = function (_Component) {
  _inherits(Explanation, _Component);

  function Explanation() {
    _classCallCheck(this, Explanation);

    return _possibleConstructorReturn(this, (Explanation.__proto__ || Object.getPrototypeOf(Explanation)).apply(this, arguments));
  }

  _createClass(Explanation, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          explanation = _props.explanation,
          wasCorrect = _props.wasCorrect,
          onNextClick = _props.onNextClick;


      return (0, _preact.h)(
        _FocusOnEnter.FocusOnEnter,
        null,
        (0, _preact.h)(
          'p',
          null,
          (0, _preact.h)(
            'strong',
            null,
            wasCorrect ? 'Riktig! ' : 'Feil! '
          ),
          explanation
        ),
        (0, _preact.h)(
          _Button.Button,
          { onClick: onNextClick },
          'Neste'
        )
      );
    }
  }]);

  return Explanation;
}(_preact.Component);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuestionView = undefined;

var _preact = __webpack_require__(0);

var _Question = __webpack_require__(54);

var _Options = __webpack_require__(55);

var _Box = __webpack_require__(6);

//  @jsx h

var QuestionView = function QuestionView(_ref) {
  var currentQuestion = _ref.currentQuestion,
      onAnswerClick = _ref.onAnswerClick;

  return (0, _preact.h)(
    _Box.Box,
    null,
    (0, _preact.h)(_Question.Question, { question: currentQuestion }),
    (0, _preact.h)(_Options.Options, { options: currentQuestion.options, onAnswerClick: onAnswerClick })
  );
};

exports.QuestionView = QuestionView;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Question = undefined;

var _preact = __webpack_require__(0);

var _FocusOnEnter = __webpack_require__(5);

//  @jsx h
var Question = exports.Question = function Question(props) {
  var description = props.question.description;

  return (0, _preact.h)(
    _FocusOnEnter.FocusOnEnter,
    null,
    (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'p',
        null,
        description
      )
    )
  );
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Options = undefined;

var _preact = __webpack_require__(0);

var _Option = __webpack_require__(56);

var _Options = __webpack_require__(58);

var _Options2 = _interopRequireDefault(_Options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Options = exports.Options = function Options(props) {
  var options = props.options,
      onAnswerClick = props.onAnswerClick;

  return (0, _preact.h)(
    'ol',
    { 'class': _Options2.default.options },
    options.map(function (option) {
      return (0, _preact.h)(_Option.Option, { key: option.response, option: option, onAnswerClick: onAnswerClick });
    })
  );
}; //  @jsx h

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = undefined;

var _preact = __webpack_require__(0);

var _Button = __webpack_require__(3);

var _Option = __webpack_require__(57);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = exports.Option = function Option(props) {
  var option = props.option,
      onAnswerClick = props.onAnswerClick;

  return (0, _preact.h)(
    'li',
    { 'class': _Option2.default.option },
    (0, _preact.h)(
      _Button.Button,
      { onClick: function onClick() {
          return onAnswerClick(option.correct);
        } },
      option.response
    )
  );
}; //  @jsx h

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"option":"dh-dh-plast-quiz-option"};

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"options":"dh-dh-plast-quiz-options"};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Foreground = undefined;

var _preact = __webpack_require__(0);

var _index = __webpack_require__(60);

var _index2 = _interopRequireDefault(_index);

var _dhUtils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Foreground = function Foreground(_ref) {
  var children = _ref.children,
      centered = _ref.centered,
      ariaHidden = _ref.ariaHidden;

  return (0, _preact.h)(
    'div',
    { 'class': (0, _dhUtils.bem)(_index2.default.foreground, { centered: centered }), 'aria-hidden': ariaHidden },
    (0, _preact.h)(
      'div',
      { 'class': _index2.default.foreground__inner },
      children
    )
  );
}; //  @jsx h

exports.Foreground = Foreground;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"foreground":"dh-dh-plast-quiz-foreground","app--is-android-app":"dh-dh-plast-quiz-app--is-android-app","foreground--centered":"dh-dh-plast-quiz-foreground--centered","foreground__inner":"dh-dh-plast-quiz-foreground__inner"};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = undefined;

var _preact = __webpack_require__(0);

var _PositionIndicator = __webpack_require__(62);

var _Logo = __webpack_require__(64);

var _ButtonGroup = __webpack_require__(66);

var _index = __webpack_require__(68);

var _index2 = _interopRequireDefault(_index);

var _Router = __webpack_require__(12);

var _constants = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESULT_VIEW = _constants.PATHS.RESULT_VIEW,
    QUESTION_VIEW = _constants.PATHS.QUESTION_VIEW,
    EXPLANATION_VIEW = _constants.PATHS.EXPLANATION_VIEW; //  @jsx h

var Overlay = function Overlay(_ref) {
  var questions = _ref.questions,
      answers = _ref.answers,
      path = _ref.path,
      questionNumber = _ref.questionNumber,
      toggleModal = _ref.toggleModal,
      restart = _ref.restart,
      ariaHidden = _ref.ariaHidden;

  return (0, _preact.h)(
    'div',
    { 'class': _index2.default.overlay, 'aria-hidden': ariaHidden },
    (0, _preact.h)(_Logo.Logo, null),
    (0, _preact.h)(
      _Router.Router,
      { path: path, multiple: true },
      (0, _preact.h)(_PositionIndicator.PositionIndicator, {
        questionNumber: questionNumber,
        questions: questions,
        answers: answers,
        path: [QUESTION_VIEW, EXPLANATION_VIEW]
      }),
      (0, _preact.h)(_ButtonGroup.ButtonGroup, {
        path: [RESULT_VIEW],
        toggleModal: toggleModal,
        restart: restart
      })
    )
  );
};

exports.Overlay = Overlay;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PositionIndicator = undefined;

var _preact = __webpack_require__(0);

var _PositionIndicator = __webpack_require__(63);

var _PositionIndicator2 = _interopRequireDefault(_PositionIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  @jsx h

var PositionIndicator = function PositionIndicator(_ref) {
  var answers = _ref.answers,
      questions = _ref.questions,
      questionNumber = _ref.questionNumber;

  var target = questions.length;

  return (0, _preact.h)(
    'div',
    { 'class': _PositionIndicator2.default['position-indicator__container'] },
    (0, _preact.h)(
      'span',
      { 'class': _PositionIndicator2.default['position-indicator'] },
      questionNumber + 1,
      ' av ',
      target
    )
  );
};
exports.PositionIndicator = PositionIndicator;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"position-indicator__container":"dh-dh-plast-quiz-position-indicator__container","position-indicator":"dh-dh-plast-quiz-position-indicator"};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = undefined;

var _preact = __webpack_require__(0);

var _dhUtils = __webpack_require__(1);

var _Logo = __webpack_require__(65);

var _Logo2 = _interopRequireDefault(_Logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = function Logo(_ref) {
  var isBlack = _ref.isBlack,
      isHidden = _ref.isHidden;

  return (0, _preact.h)(
    'div',
    { 'class': _Logo2.default.logo__wrapper },
    (0, _preact.h)('a', {
      'aria-hidden': isHidden,
      'class': (0, _dhUtils.bem)(_Logo2.default.logo, { black: isBlack }),
      href: 'https://www.nrk.no',
      rel: 'home',
      'aria-label': 'G\xE5 til NRK.no'
    })
  );
}; //  @jsx h

// because of aria-label:
/* eslint-disable jsx-a11y/anchor-has-content */

exports.Logo = Logo;

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"logo__wrapper":"dh-dh-plast-quiz-logo__wrapper","logo":"dh-dh-plast-quiz-logo","logo--black":"dh-dh-plast-quiz-logo--black"};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = undefined;

var _preact = __webpack_require__(0);

var _Button = __webpack_require__(3);

var _ButtonGroup = __webpack_require__(67);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGroup = function ButtonGroup(_ref) {
  var restart = _ref.restart,
      toggleModal = _ref.toggleModal;

  return (0, _preact.h)(
    'div',
    { 'class': _ButtonGroup2.default['button-group'] },
    (0, _preact.h)(
      _Button.Button,
      {
        onClick: toggleModal,
        modifiers: ['icon', 'inverted'],
        'aria-label': '\xC5pne ekstra informasjon'
      },
      (0, _preact.h)(
        'span',
        { 'aria-hidden': true },
        (0, _preact.h)(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '2 3 10 10',
            width: '200px'
          },
          (0, _preact.h)('path', { d: 'M7.5 3.62c-.33 0-.6.2-.6.53 0 .32.27.52.6.52.32 0 .56-.2.56-.52s-.25-.53-.57-.53zm.45 2.1H6.4v.5l.75.22v4.35l-.77.22v.48h2.34v-.48l-.77-.23V5.7z' })
        )
      )
    )
  );
}; //  @jsx h

exports.ButtonGroup = ButtonGroup;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"button-group":"dh-dh-plast-quiz-button-group","button":"dh-dh-plast-quiz-button"};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"dh-dh-plast-quiz-overlay"};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var matches = function matches(currentPath) {
  for (var _len = arguments.length, paths = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    paths[_key - 1] = arguments[_key];
  }

  return paths.indexOf(currentPath) > -1;
};

exports.matches = matches;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = undefined;

var _preact = __webpack_require__(0);

var _Button = __webpack_require__(3);

var _FocusOnEnter = __webpack_require__(5);

var _dhUtils = __webpack_require__(1);

var _index = __webpack_require__(71);

var _index2 = _interopRequireDefault(_index);

var _text = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  @jsx h

var Modal = function Modal(_ref) {
  var isShowing = _ref.isShowing,
      toggleModal = _ref.toggleModal;

  return (0, _preact.h)(
    'div',
    { 'class': (0, _dhUtils.bem)(_index2.default.modal, { hidden: !isShowing }) },
    isShowing && (0, _preact.h)(ModalContent, { isShowing: isShowing, toggleModal: toggleModal })
  );
};

var ModalContent = function ModalContent(_ref2) {
  var isShowing = _ref2.isShowing,
      toggleModal = _ref2.toggleModal;

  return (0, _preact.h)(
    'div',
    { 'class': (0, _dhUtils.bem)(_index2.default.modal__content) },
    (0, _preact.h)(
      'div',
      { 'class': _index2.default['modal__button-wrapper'] },
      (0, _preact.h)(
        _Button.Button,
        {
          onClick: toggleModal,
          modifiers: ['icon', 'inverted'],
          'aria-label': 'Lukk ekstra informasjon'
        },
        (0, _preact.h)(
          'span',
          { 'aria-hidden': true },
          (0, _preact.h)(
            'svg',
            { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 15 15' },
            (0, _preact.h)('path', {
              stroke: 'currentColor',
              strokeLinecap: 'round',
              d: 'M2 2l11 11M2 13L13 2'
            })
          )
        )
      )
    ),
    (0, _preact.h)(
      _FocusOnEnter.FocusOnEnter,
      null,
      (0, _preact.h)(
        'h2',
        null,
        _text.byline.title
      ),
      (0, _preact.h)(
        'ul',
        null,
        _text.byline.content.map(function (contentItem) {
          return (0, _preact.h)(
            'li',
            { key: contentItem.title },
            (0, _preact.h)(
              'h4',
              null,
              contentItem.title
            ),
            (0, _preact.h)(
              'ul',
              null,
              contentItem.people.map(function (person) {
                return (0, _preact.h)(
                  'li',
                  { key: person },
                  person
                );
              })
            )
          );
        })
      )
    )
  );
};

exports.Modal = Modal;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modal":"dh-dh-plast-quiz-modal","modal--hidden":"dh-dh-plast-quiz-modal--hidden","modal__content":"dh-dh-plast-quiz-modal__content","modal__button-wrapper":"dh-dh-plast-quiz-modal__button-wrapper"};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fullscreen = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _preact = __webpack_require__(0);

var _debounce = __webpack_require__(73);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  @jsx h

var Fullscreen = function (_Component) {
  _inherits(Fullscreen, _Component);

  function Fullscreen() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Fullscreen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Fullscreen.__proto__ || Object.getPrototypeOf(Fullscreen)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: 0
    }, _this.debouncedResize = null, _this.componentDidMount = function () {
      _this.setState({ height: window.innerHeight });
      _this.debouncedResize = (0, _debounce.debounce)(_this.onResize, 16.666);
      window.addEventListener('resize', _this.debouncedResize);
    }, _this.componentWillUnmount = function () {
      window.addEventListener('resize', _this.debouncedResize);
    }, _this.onResize = function () {
      _this.setState({ height: window.innerHeight });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Fullscreen, [{
    key: 'render',
    value: function render() {
      return (0, _preact.h)(
        'div',
        { 'class': this.props.class || '', style: { height: this.state.height } },
        this.props.children
      );
    }
  }]);

  return Fullscreen;
}(_preact.Component);

exports.Fullscreen = Fullscreen;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function debounce(func, wait, immediate) {
  var timeout = void 0;

  return function () {
    var context = this;
    var args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

exports.debounce = debounce;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, n) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : n(e["dh-analytics-utils"] = {});
}(undefined, function (e) {
  "use strict";
  var n = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }return e;
  };e.createGoogleAnalyticsTracker = function (e, t) {
    var r,
        o,
        i,
        a,
        l,
        c,
        s = t.name,
        u = t.gaPropertyId,
        d = t.self,
        p = t.context,
        f = t.errorHandler,
        v = (r = d.id, o = p.id, i = d.title, a = d.publishedDate, l = r === o, c = document.referrer, { dimension1: r ? "pp:" + r : null, dimension2: i || null, dimension3: a ? String(a.getFullYear()) : null, dimension4: a ? String(a.getMonth() + 1) : null, dimension5: a ? String(a.getDate()) : null, dimension6: c.replace(/^(https?:\/\/)?www./, "$1"), dimension7: c.replace(/^(https?:\/\/)/, "").replace(/^www./, ""), dimension10: l ? null : o ? "pp:" + o : null }),
        w = Promise.resolve(e).then(function () {
      return window.ga("create", u, "auto", s), window.ga(s + ".set", "anonymizeIp", !0);
    });return { sendEvent: function sendEvent(e) {
        w.then(function () {
          return window.ga(s + ".send", "event", function (e, t) {
            var r = {};e.hasOwnProperty("category") && (r.eventCategory = e.category), e.hasOwnProperty("action") && (r.eventAction = e.action), e.hasOwnProperty("label") && (r.eventLabel = e.label), e.hasOwnProperty("value") && (r.eventValue = e.value), r.nonInteraction = e.nonInteraction || !1;var o = n({}, t, e.fieldsObject);return n({}, r, o);
          }(e, v));
        }).catch(function (e) {
          f && f(e);
        });
      } };
  }, Object.defineProperty(e, "__esModule", { value: !0 });
});

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContextId = getContextId;
var POLOPOLY_ID_REGEX = /[1-9]{1,2}\.\d+/g;

function getContextId(url) {
  return extractPolopolyIdFromString(url);
}

function extractPolopolyIdFromString(str) {
  var matches = str.match(POLOPOLY_ID_REGEX);
  if (matches && matches.length) {
    return matches[0];
  }
  return null;
}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGlobalGa = getGlobalGa;
function getGlobalGa() {
  if (window.ga) {
    return window.ga;
  }
  var pollCount = 0;
  var maxPollCount = 10;
  var intervalMs = 50;
  return new Promise(function (resolve, reject) {
    var intervalId = setInterval(function () {
      pollCount++;
      if (window.ga) {
        clearInterval(intervalId);
        resolve(window.ga);
      } else if (pollCount === maxPollCount) {
        return reject(new Error('window.ga took too long to appear'));
      }
    }, intervalMs);
  });
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function addTouchClass(el) {
  for (var _len = arguments.length, classes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classes[_key - 1] = arguments[_key];
  }

  var add = function add() {
    classes.map(function (c) {
      return el.classList.add(c);
    });
    el.removeEventListener('touchstart', add);
  };

  el.addEventListener('touchstart', add);
}

exports.addTouchClass = addTouchClass;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// v1-bundle-b12c9cc3bead5a4ba5b1.js